<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 1024 1024" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g>
      <path data-follow-fill="currentColor" d="M917.5 340.7c-22.2-52.4-53.8-99.4-94.3-139.9-40.4-40.4-87.4-72.1-139.9-94.3C629 83.6 571.4 72 512 72s-117 11.6-171.3 34.5c-52.4 22.2-99.4 53.8-139.9 94.3-40.4 40.4-72.1 87.4-94.3 139.9C83.6 395 72 452.6 72 512s11.6 117 34.5 171.3c22.2 52.4 53.8 99.4 94.3 139.9 40.4 40.4 87.4 72.1 139.9 94.3C395 940.4 452.6 952 512 952s117-11.6 171.3-34.5c52.4-22.2 99.4-53.8 139.9-94.3 40.4-40.4 72.1-87.4 94.3-139.9C940.4 629 952 571.4 952 512s-11.6-117-34.5-171.3zM513.2 895.5C302 895.5 130.7 724.2 130.7 513c0-211.3 171.3-382.5 382.5-382.5 211.3 0 382.5 171.2 382.5 382.5 0 211.2-171.2 382.5-382.5 382.5z" :fill="_fill" />
      <path data-follow-fill="currentColor" d="M598 417.3c-3.8-.5-7.1-2.9-8.8-6.4l-66.7-135.2c-4.3-8.7-16.8-8.7-21 0l-66.7 135.2c-1.7 3.4-5 5.8-8.8 6.4L276.8 439c-9.6 1.4-13.5 13.2-6.5 20l108 105.2c2.7 2.7 4.1 6.6 3.4 10.4L356 723.1c-1.7 9.6 8.4 16.8 17 12.4l133.5-70.1c3.4-1.8 7.5-1.8 10.9 0l133.5 70.1c8.6 4.5 18.7-2.8 17-12.4l-25.5-148.6c-.6-3.8.6-7.7 3.4-10.4l107.9-105.2c7-6.8 3.1-18.6-6.5-20L598 417.3z" :fill="_fill" />
    </g>
  </svg>
</template>
<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1.4em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}

@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
